const ns = "INVENTORY_REPORTS_CATEGORY_OVERVIEW";
export const REQUEST = `${ns}_REQUEST`;
export const RECEIVE = `${ns}_RECEIVE`;
